/**
 * Animated cursor shown while Stella is mid-stream. Honours
 * `prefers-reduced-motion` per constitution Principle VII.
 */

export function StreamingCursor() {
  return (
    <span
      aria-label="Stella is replying"
      role="status"
      className="ml-1 inline-block h-3 w-1 translate-y-0.5 animate-pulse bg-starz-gold align-baseline motion-reduce:animate-none"
    />
  );
}
